import { AdminActionTypes } from "./admin-types";

//api calls
import { GetAllUsers } from "../../services/api/user-api";
import { GetAllRoles } from "../../services/api/role-api";
import { GetAllDepartments } from "../../services/api/department-api";
import {GetMostRecentLogs} from '../../services/api/log-activity-api';
import {GetProjectTemplates, GetProjectTemplate } from '../../services/api/project-template-api';

/// USERS

export const fetchUsersStart = () => ({
    type: AdminActionTypes.FETCH_USERS_START
})

export const fetchUsersFailure = () => ({
    type: AdminActionTypes.FETCH_USERS_FAILURE
})

export const fetchUsersSuccess = (payload) => ({
    type: AdminActionTypes.FETCH_USERS_SUCCESS,
    payload: payload
})



export const fetchAllUsersStart = () => ({
    type: AdminActionTypes.FETCH_ALL_USERS_START
})

export const fetchAllUsersFailure = () => ({
    type: AdminActionTypes.FETCH_ALL_USERS_FAILURE
})

export const fetchAllUsersSuccess = (allUsers) => ({
    type: AdminActionTypes.FETCH_ALL_USERS_SUCCESS,
    payload: allUsers
})


export const setUsersOnPage = (usersOnPage) => ({
    type: AdminActionTypes.SET_USERS_ON_PAGE,
    payload: usersOnPage

})

export const setSearchQuery = (searchQuery) => ({
    type: AdminActionTypes.SET_SEARCH_QUERY,
    payload: searchQuery
})

export const setSearchQueryUsers = (searchQuery) => ({
    type: AdminActionTypes.SET_SEARCH_QUERY_USERS,
    payload: searchQuery
})

// export const setNumUsers = (numUsers) => ({
//     type: AdminActionTypes.SET_SEARCH_QUERY_USERS,
//     payload: numUsers
// })

export const fetchAllUsers = () => {
    return async dispatch => {
        try {
            
            dispatch(fetchAllUsersStart()); //starting the loading process
            
            const allUsers = await GetAllUsers({ pageSize: 1000000, pageNumber: 1, sortDesc: false, sortBy: "name", filters: [] });

            //allUsers.sort();
            //let allUsers = [];

            let users = [];

            //if pageSize >1000 then we are setting our state for all users
            
            allUsers.users.forEach(async user => {
                users.push({
                    'user': user,
                })
            });

            dispatch(fetchAllUsersSuccess(users)); //setting all users
            
            return users; //exit function 
        }
    
        catch (error) {
            dispatch(fetchAllUsersFailure())
            console.log(error);
        }  
    }
}



export const fetchUsers = (searchQuery) => {
    return async dispatch => {
        try {
            
            dispatch(fetchUsersStart()); //starting the loading process
            
            const allUsers = await GetAllUsers(searchQuery);

            //allUsers.sort();
            //let allUsers = [];

            let users = [];

            //if pageSize >1000 then we are setting our state for all users
            
            allUsers.users.forEach(user => {
                users.push({
                    'user': user,
                })
            });

            let payload = [users, allUsers.count]

            dispatch(fetchUsersSuccess(payload));
            dispatch(setSearchQueryUsers(searchQuery));

            return users;
       
        }
            
    
        catch (error) {
            dispatch(fetchUsersFailure())
            console.log(error);
        }  
    }
}

export const addSelectedUser = (userId) => ({
    type: AdminActionTypes.ADD_SELECTED_USER,
    payload: userId
})

export const deleteSelectedUser = (userId) => ({
    type: AdminActionTypes.DELETE_SELECTED_USER,
    payload: userId
})

export const setSelectedUser = (userIdList) => ({
    type: AdminActionTypes.SET_SELECTED_USER,
    payload: userIdList
})


export const setAdminTab = (tab) => ({
    type: AdminActionTypes.SET_ADMIN_TAB,
    payload: tab
})

////// ROLES


export const fetchRolesStart = () => ({
    type: AdminActionTypes.FETCH_ROLES_START
})

export const fetchRolesFailure = () => ({
    type: AdminActionTypes.FETCH_ROLES_FAILURE
})

export const fetchRolesSuccess = (users) => ({
    type: AdminActionTypes.FETCH_ROLES_SUCCESS,
    payload: users
})

export const setRolesOnPage = (rolesOnPage) => ({
    type: AdminActionTypes.SET_ROLES_ON_PAGE,
    payload: rolesOnPage

})

export const setSearchRolesQuery = (searchQuery) => ({
    type: AdminActionTypes.SET_SEARCH_ROLES_QUERY,
    payload: searchQuery
})

export const addSelectedRole = (id) => ({
    type: AdminActionTypes.ADD_SELECTED_ROLE,
    payload: id
})

export const deleteSelectedRole = (id) => ({
    type: AdminActionTypes.DELETE_SELECTED_ROLE,
    payload: id
})

export const setSelectedRoles = (idList) => ({
    type: AdminActionTypes.SET_SELECTED_ROLE,
    payload: idList
})


// Consider moving get department to its own thing?
export const fetchRoles = (searchQuery) => {
    return async dispatch => {
        try {

            dispatch(fetchRolesStart()); //starting loading process

            const allRoles = await GetAllRoles(searchQuery);

            const roles = [];

            allRoles.roles.forEach(role => {
                roles.push({role: role});
            });

            // await Promise.all(allRoles.map(async (role) => {
            //     let department = await GetDepartment(role.role.companyID);
            //     role.department = department
            //     // console.log(contents)
            // }));
               
            let payload = [roles, allRoles.count];

            dispatch(fetchRolesSuccess(payload));
            dispatch(setSearchRolesQuery(searchQuery));


            dispatch(setRolesOnPage(roles));
            
            return allRoles; //exit function 
                
    
        } catch (error) {
            dispatch(fetchRolesFailure())
            console.log(error);
        }

    }   
}

////// DEPARTMENTS
//deprecate department
export const getAllDepartments = (searchQuery) => {
    return async dispatch => {
        try {
            let departments;
            dispatch(fetchDepartmentsStart()); //starting loading process

            departments = await GetAllDepartments(searchQuery);
            dispatch(setAllDepartments(departments.departments));
            
            return departments;

        } catch (error) {
            console.log(error)
        }
    }
}

export const setAllDepartments = (departments) =>({
    type: AdminActionTypes.SET_ALL_DEPARTMENTS,
    payload: departments
})

export const fetchDepartments = (searchQuery) => {
    return async dispatch => {
        try {
            const departments1 = [];
            let departments;
            dispatch(fetchDepartmentsStart()); //starting loading process
            //const allDepartments = await GetAllDepartments({pageSize: 1000000, pageNumber: 1, sortDesc: false, sortBy: "name",  filters: []}); //temporary until backend sends us total num departments

            departments = await GetAllDepartments(searchQuery);
            departments.departments.forEach(department => {
                departments1.push({department: department});
            });

            let payload = [departments1, departments.count];

            dispatch(fetchDepartmentsSuccess(payload)); //setting all users
            dispatch(setSearchDepartmentsQuery(searchQuery));

        
            dispatch(setDepartmentsOnPage(departments));

            return departments;

        } catch (error) {
            dispatch(fetchDepartmentsFailure())
            console.log(error);
        }

    }   
}

export const fetchDepartmentsStart = () => ({
    type: AdminActionTypes.FETCH_DEPARTMENTS_START
})

export const fetchDepartmentsFailure = () => ({
    type: AdminActionTypes.FETCH_DEPARTMENTS_FAILURE
})

export const fetchDepartmentsSuccess = (payload) => ({
    type: AdminActionTypes.FETCH_DEPARTMENTS_SUCCESS,
    payload: payload
})

export const setDepartmentsOnPage = (departmentsOnPage) => ({
    type: AdminActionTypes.SET_DEPARTMENTS_ON_PAGE,
    payload: departmentsOnPage

})

export const setSearchDepartmentsQuery = (searchQuery) => ({
    type: AdminActionTypes.SET_SEARCH_DEPARTMENTS_QUERY,
    payload: searchQuery
})


export const addSelectedDepartment = (id) => ({
    type: AdminActionTypes.ADD_SELECTED_DEPARTMENT,
    payload: id
})

export const deleteSelectedDepartment = (id) => ({
    type: AdminActionTypes.DELETE_SELECTED_DEPARTMENT,
    payload: id
})

export const setSelectedDepartments = (idList) => ({
    type: AdminActionTypes.SET_SELECTED_DEPARTMENT,
    payload: idList
})

/// LOG-ACTIVITY

export const fetchLogsStart = () => ({
    type: AdminActionTypes.FETCH_LOGS_START
})

export const fetchLogsFailure = () => ({
    type: AdminActionTypes.FETCH_LOGS_FAILURE
})

export const fetchLogsSuccess = (payload) => ({
    type: AdminActionTypes.FETCH_LOGS_SUCCESS,
    payload: payload
})


export const fetchLogs = (searchQuery) => {
    return async dispatch => {
        try {
            dispatch(fetchLogsStart()); //starting the loading process
            
            const allLogs = await GetMostRecentLogs(searchQuery);

            let logs = [];
            
            allLogs.lst.forEach(async log => {

                logs.push({
                    'log': log
                })
            });

            let payload = [logs, allLogs.allCounts];

            dispatch(fetchLogsSuccess(payload)); 
            dispatch(setSearchLogsQuery(searchQuery));

            
            return logs; //exit function 
   
        }

        catch (error) {
            console.log(error);
        }  
    }
}

export const setSearchLogsQuery = (searchQuery) => ({
    type: AdminActionTypes.SET_SEARCH_LOGS_QUERY,
    payload: searchQuery
})

export const addSelectedLog = (id) => ({
    type: AdminActionTypes.ADD_SELECTED_LOG,
    payload: id
})

export const deleteSelectedLog = (id) => ({
    type: AdminActionTypes.DELETE_SELECTED_LOG,
    payload: id
})

export const setSelectedLogs = (idList) => ({
    type: AdminActionTypes.SET_SELECTED_LOG,
    payload: idList
})

////// Templates


export const fetchTemplatesStart = () => ({
    type: AdminActionTypes.FETCH_TEMPLATES_START
})

export const fetchTemplatesFailure = () => ({
    type: AdminActionTypes.FETCH_TEMPLATES_FAILURE
})

export const fetchTemplatesSuccess = (payload) => ({
    type: AdminActionTypes.FETCH_TEMPLATES_SUCCESS,
    payload: payload
})

export const setTemplatesOnPage = (templatesOnPage) => ({
    type: AdminActionTypes.SET_TEMPLATES_ON_PAGE,
    payload: templatesOnPage

})

export const setSearchTemplatesQuery = (searchQuery) => ({
    type: AdminActionTypes.SET_SEARCH_TEMPLATES_QUERY,
    payload: searchQuery
})

export const addSelectedTemplate = (id) => ({
    type: AdminActionTypes.ADD_SELECTED_TEMPLATE,
    payload: id
})

export const deleteSelectedTemplate = (id) => ({
    type: AdminActionTypes.DELETE_SELECTED_TEMPLATE,
    payload: id
})

export const setSelectedTemplate = (idList) => ({
    type: AdminActionTypes.SET_SELECTED_TEMPLATE,
    payload: idList
})


export const fetchTemplates = (searchQuery) => {
    return async dispatch => {
        try {

            dispatch(fetchTemplatesStart()); //starting loading process

            const allTemplates = await GetProjectTemplates(searchQuery);
            const templates = [];

            allTemplates.task.forEach(template => {
                templates.push({template: template});
            });
               
            let payload = [templates, allTemplates.counts];

            dispatch(fetchTemplatesSuccess(payload));
            dispatch(setSearchTemplatesQuery(searchQuery));


            dispatch(setTemplatesOnPage(templates));
            return allTemplates; //exit function 
                
    
        } catch (error) {
            dispatch(fetchTemplatesFailure())
            console.log(error);
        }

    }   
}


////// Template Tasks


export const fetchTemplateTasksStart = () => ({
    type: AdminActionTypes.FETCH_TEMPLATE_TASKS_START
})

export const fetchTemplateTasksFailure = () => ({
    type: AdminActionTypes.FETCH_TEMPLATE_TASKS_FAILURE
})

export const fetchTemplateTasksSuccess = (payload) => ({
    type: AdminActionTypes.FETCH_TEMPLATE_TASKS_SUCCESS,
    payload: payload
})

export const setTemplateTasksOnPage = (templateTasksOnPage) => ({
    type: AdminActionTypes.SET_TEMPLATE_TASKS_ON_PAGE,
    payload: templateTasksOnPage

})

export const setSearchTemplateTasksQuery = (searchQuery) => ({
    type: AdminActionTypes.SET_SEARCH_TEMPLATE_TASKS_QUERY,
    payload: searchQuery
})

export const addSelectedTemplateTasks = (id) => ({
    type: AdminActionTypes.ADD_SELECTED_TEMPLATE_TASKS,
    payload: id
})

export const deleteSelectedTemplateTasks = (id) => ({
    type: AdminActionTypes.DELETE_SELECTED_TEMPLATE_TASKS,
    payload: id
})

export const setSelectedTemplateTasks = (idList) => ({
    type: AdminActionTypes.SET_SELECTED_TEMPLATE_TASKS,
    payload: idList
})


export const fetchTemplateTasks = (searchQuery) => {
    return async dispatch => {
        try {
            dispatch(fetchTemplateTasksStart()); //starting loading process

            const allTasksQuery = { ...searchQuery, pageSize: 1000000000, pageNumber: 1 };
            const template = await GetProjectTemplate({ ...searchQuery });
            const allTasks = await GetProjectTemplate({ ...allTasksQuery });
            const tasks = template.tasks;

            let payload = [tasks, allTasks?.tasks?.length];
            
            dispatch(fetchTemplateTasksSuccess(payload));
            dispatch(setSearchTemplateTasksQuery(searchQuery));

            dispatch(setTemplateTasksOnPage(tasks));
            return tasks; //exit function
        } catch (error) {
            dispatch(fetchTemplateTasksFailure())
            console.log(error);
        }

    }   
}

export const showTemplateSubtask = (assignID) => {
    return async (dispatch, getState) => {
        
        const tasks = getState().admin.templateTasks;
        let tasksWithSubtaskOpen = [];
        
        try {
            tasks.forEach(task => 
                task.assignID === assignID ? tasksWithSubtaskOpen.push({ ...task, 'subtaskOpen': !task.subtaskOpen}) : tasksWithSubtaskOpen.push(task)
            )
        } catch (error) {
            console.log(error);
        }
       
        const payload = [tasksWithSubtaskOpen, tasksWithSubtaskOpen.length]
        dispatch(fetchTemplateTasksSuccess(payload));
        dispatch(setTemplateTasksOnPage(tasksWithSubtaskOpen));
    }
}
